import { render, staticRenderFns } from "./changePass.vue?vue&type=template&id=74ade85e&scoped=true&"
import script from "./changePass.vue?vue&type=script&lang=js&"
export * from "./changePass.vue?vue&type=script&lang=js&"
import style0 from "./changePass.vue?vue&type=style&index=0&id=74ade85e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ade85e",
  null
  
)

export default component.exports